import { AppSelect2Field } from 'components/shared/FormComponents/AppSelect2Field'
import { useField, useFormikContext } from 'formik'
import React, { useEffect, useState } from 'react'
import { useGetChatterReportProgramsListQuery } from 'store/services/clients/reports-v2/chatterReports'
import parse from "html-react-parser";

export const QuestionChatterProgramDescription = ({ question, onChange, assignedGroupLeaders, caseVeteran }) => {
    const [programSearch, setProgramSearch] = useState("")
    const { data: programsList, isLoading: programsListLoading } = useGetChatterReportProgramsListQuery({ search: programSearch, assignedTherapistId: caseVeteran?.caseTherapist?.id })
    const programOptions = programsList?.records?.map((item) => ({ label: item?.program?.name, value: item?.id, description: item?.description, program: item?.program }))
    const { values, setFieldValue } = useFormikContext()
    const [field, meta] = question?.id ? useField(question?.id) : [];

    useEffect(() => {
        if(!programOptions?.length || !assignedGroupLeaders?.length) {
            return;
        }

        const selectedProgram = programOptions.find((program) => program?.program?.id === assignedGroupLeaders[0]?.chatter_program_id)
        selectedProgram && handleSelect(selectedProgram);
    }, [JSON.stringify(programOptions), JSON.stringify(assignedGroupLeaders)]);

    const handleSelect = (selected) => {
        const answer = programOptions?.find((item) => item?.value == selected?.value).description;
        const x = {
            ...values[question?.id],
            answer
        }
        setFieldValue(question?.id, x);
        setFieldValue("program_id", selected);
        // setFieldValue(`screening_results[${index}].goal_id`, null); // Example: reset goal_id
        typeof onChange === "function" && onChange(selected);
    }
    
    return (
        <div className="d-flex  gap-3">
            <label style={{ whiteSpace: "nowrap", marginTop: "11px", fontWeight: "700", fontSize: '14px' }} className="discharge-screen-label">{`CHOOSE A PROGRAM DESCRIPTION`}</label>
            <div className="w-100">
                <AppSelect2Field
                    isDisabled={false}
                    name={`program_id`}
                    placeholder="Select Program"
                    classNamePrefix="khan"
                    onInputChange={(e) => console.log('e', e)}
                    // style={{zIndex: 100}}
                    option={programOptions}
                    isLoading={false}
                    onChange={handleSelect}
                />
                {
                    values?.[question?.id]?.answer &&
                    <div style={{ backgroundColor: "#F1F7FF", padding: "12px", marginTop: "10px", fontSize: "14px", fontWeight: "400" }}>
                        {parse(values?.[question?.id]?.answer || "")}
                    </div>
                }
                {(meta?.touched && meta?.error?.answer && !values?.[question?.id]?.answer) ? (
                    <div className="error">{typeof meta?.error?.answer === "string" ? meta.error?.answer : ""}</div>
                ) : null}
            </div>
        </div>
    )
}
